import axios from "axios"

const cancellationReason = {
  namespaced: true,
  state: {
    codes: [],
  },
  mutations: {
    ADD_CODES(state, data) {
      state.codes = data.reasons
    },
  },
  actions: {
    async fetchCancellationReasonCodes({ commit, state }) {
      if (state.codes.length === 0) {
        // Served by cdk-salesforce as a public, unauthenticated endpoint (was
        // /supporter/settings/cancellationreasons in sls-supporters).
        const { data } = await axios.get("/public/cancellation_reasons")
        commit("ADD_CODES", data)
      }
    },
  },
}

export {
  cancellationReason,
}
